import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';

import { EmptyClassroom } from '@innovamat/glimmer-assets';
import { Typography } from '@innovamat/glimmer-components';

import { useOrganization } from '../../../../hooks/use-organization';
import { SchoolJourneysDropdown } from '../school-journeys-dropdown/school-journeys-dropdown';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const Text = styled.div`
  text-align: center;
`;

const SubtleText = styled(Typography.Body1)`
  color: ${({ theme }) =>
    theme.tokens.color.alias.cm.text['text-subtle'].value};
  max-width: 800px;
`;

function SchoolJourneysEmptyState(): JSX.Element {
  const { t } = useTranslation();
  const { isRosteringEnabled } = useOrganization();

  return (
    <Container>
      <EmptyClassroom />
      <Text>
        <Typography.H4>
          {t('select-groups.select-groups.empty-state.title')}
        </Typography.H4>
        <SubtleText>
          {isRosteringEnabled ? (
            <Trans
              i18nKey="rostering.action-disabled.message"
              components={{
                b: <b />,
              }}
            />
          ) : (
            t('select-groups.select-groups.empty-state.description')
          )}
        </SubtleText>
      </Text>

      <SchoolJourneysDropdown />
    </Container>
  );
}

export { SchoolJourneysEmptyState };
